module.exports = __webpack_public_path__ + "static/media/vna.bdb51daf.gif";